import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SEO } from "../components/SEO";
import { QuoteCTA } from "../components/CTA";
import { PROJECTS } from "../data/site";

export default function Projects() {
  return (
    <>
      <SEO title="Projects | Storage Solutions Delivered — CustoRacks"
        description="Explore storage solutions delivered by CustoRacks for different warehouse and industrial requirements — pallet racking, shelving and mezzanine installations." />
      <section className="page-hero" data-testid="projects-hero">
        <div className="container">
          <div className="crumbs">Home / Projects</div>
          <h1>Our Projects</h1>
          <p>Explore storage solutions delivered for different warehouse and industrial requirements.</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="grid-3">
            {PROJECTS.map((pr) => (
              <article className="card" key={pr.slug} data-testid={`projects-page-card-${pr.slug}`}>
                <Link to={`/projects/${pr.slug}`} className="card-img"><img src={pr.image} alt={pr.title} loading="lazy" /></Link>
                <div className="card-body">
                  <span className="card-cat">{pr.system}</span>
                  <h3>{pr.title}</h3>
                  <div className="project-meta"><span>{pr.location}</span><span>{pr.industry}</span></div>
                  <p>{pr.description}</p>
                  <Link to={`/projects/${pr.slug}`} className="card-link" data-testid={`projects-view-${pr.slug}`}>View Project <ArrowRight size={14} /></Link>
                </div>
              </article>
            ))}
          </div>
          <p style={{ color: "var(--muted)", fontSize: 13, marginTop: 36 }} data-testid="projects-note">
            Project entries shown are representative of typical CustoRacks installations. Detailed case studies are added as projects are documented.
          </p>
        </div>
      </section>
      <QuoteCTA />
    </>
  );
}
